export default function LogoMark({ size = 34 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Ujjwal Praveen logo">
            <path d="M20 35L50 18L80 35V65L50 82L20 65V35Z" stroke="#00F2FE" strokeWidth="4" strokeLinejoin="round" />
            <path d="M35 42L50 33L65 42V58L50 67L35 58V42Z" fill="#00F2FE" fillOpacity="0.15" stroke="#00E676" strokeWidth="3" />
            <path d="M50 18V82M20 35L80 65M80 35L20 65" stroke="rgba(255,255,255,0.15)" strokeWidth="2" />
        </svg>
    );
}
